import React from 'react';
import { Grid2 as Grid, Skeleton } from '@mui/material';

const SkeletonForm = () => {
  return (
    <Grid
      container
      spacing={3}
    >
      <Grid size={12}>
        <Skeleton
          variant={'rounded'}
          animation="wave"
          sx={{
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: 'divider',
          }}
          height={56}
        />
      </Grid>
      <Grid size={12}>
        <Skeleton
          variant={'rounded'}
          animation="wave"
          sx={{
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: 'divider',
          }}
          height={56}
        />
      </Grid>
      <Grid size={12}>
        <Skeleton
          variant={'rounded'}
          animation="wave"
          sx={{
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: 'divider',
          }}
          height={56}
        />
      </Grid>
      <Grid size={12}>
        <Skeleton
          variant={'rounded'}
          animation="wave"
          sx={{
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: 'divider',
          }}
          height={56}
        />
      </Grid>
      <Grid size={12}>
        <Skeleton
          variant={'rounded'}
          animation="wave"
          sx={{
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            borderBottomColor: 'divider',
          }}
          height={56}
        />
      </Grid>
    </Grid>
  );
};

export default SkeletonForm;
